// extracted by mini-css-extract-plugin
export default {"title":"src-common-components-error-404-page-error-404-page-module__title--3t8YG","textContainer":"src-common-components-error-404-page-error-404-page-module__textContainer--3sqS1"};